import { ComingSoonTag } from '@aibees/shared/components';
import {
  DATE_FORMAT_MM_DD_YYYY_hh_mm_a,
  fDateTime,
  fHumanReadableNumber,
} from '@aibees/shared/utils';
import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import * as SX from './sx';
import type { TreeItemMetadataBlockProps } from './types';

function TreeItemMetadataBlockComponent({ item }: TreeItemMetadataBlockProps) {
  const showRightStack =
    item.metadata?.comingSoon ||
    item.metadata?.records !== undefined ||
    item.metadata?.date;

  return (
    <Stack
      display={showRightStack ? 'flex' : 'none'}
      flexDirection="column"
      marginLeft={0.5}
    >
      <Box display="flex" alignItems="center" gap={0.5}>
        {item.metadata?.comingSoon ? (
          <ComingSoonTag size="small" />
        ) : item.metadata?.records !== undefined ? (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="end"
            sx={SX.metadataCount}
          >
            <Typography variant="body5" color="grey.500">
              {fHumanReadableNumber(item.metadata?.records)}
            </Typography>
          </Box>
        ) : null}
      </Box>

      {!item.metadata?.comingSoon && item.metadata?.date && (
        <Typography variant="body5" color="grey.500">
          {fDateTime(item.metadata?.date, DATE_FORMAT_MM_DD_YYYY_hh_mm_a)}
        </Typography>
      )}
    </Stack>
  );
}

TreeItemMetadataBlockComponent.displayName = 'TreeItemMetadataBlock';

export const TreeItemMetadataBlock = React.memo(TreeItemMetadataBlockComponent);
